// Drift Team Website 2025
// src/main.jsx
// Created by Lukas Helebrandt on 17.03.2025.
// Updated by Grok on 21.04.2025 to add AchievementsProvider

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { AchievementsProvider } from './contexts/AchievementsContext';
import './styles/variables.css';
import './styles/globals.css';
import './styles/animations.css';
import './styles/admin.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <SettingsProvider>
        <AchievementsProvider>
          <AuthProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </AuthProvider>
        </AchievementsProvider>
      </SettingsProvider>
    </BrowserRouter>
  </React.StrictMode>
);